/**
 * Modal login button component.
 */
import Button from '@components/atoms/buttons/genericButton';
import Container from '@components/atoms/container/anonymousModalLogin';
import Props from '@shared/types/props/pressable';
import Text from '@components/atoms/text/anonymousModalAccount';
import useButton from '../lib/useButton';

/**
 * Displays the modal button with the given text and action.
 */
export default function ModalButton(
  parentProps: Props & { addMargin?: boolean; tip?: string }
) {
  const { callbacks, props, buttonText, buttonTip } = useButton(parentProps);
  return (
    <Container addMargin={parentProps.addMargin}>
      <Text>{buttonTip}</Text>
      <Button {...props} {...callbacks}>
        {buttonText}
      </Button>
    </Container>
  );
}
